import React, { PropTypes } from 'react';
import MapHeader from 'components/mapHeader/mapHeader';
import Timeline from 'components/timeline/timeline';

class ItineraryDetails extends React.Component {
    render () {
        var self = this,
            itinerary = self.props.itinerary;

        return (
            <div className="itinerary-container">
                <MapHeader title={ itinerary.title } />
                <hr />
                <Timeline items={ itinerary.items } location={ self.props.location } />
            </div>
        );
    }
};

export default ItineraryDetails;


// WEBPACK FOOTER //
// ./src/app/components/itinerary/itineraryDetails.jsx